import { useMemo } from "react";
import { SxProps, Theme } from "@mui/material";
import { useSelector } from "react-redux";
import { selectors } from "../../redux-store";
import { GameStatus } from "../../redux-store/slices/game/game.interfaces";

export const useGameTitle = () => {
  const status = useSelector(selectors.getGameStatus);
  const chosenLevel = useSelector(selectors.getChosenLevel);
  const sxTitleProps = useMemo<SxProps<Theme>>(
    () => ({
      fontSize: {
        xs: "20px",
        md: "35px",
      },
      textTransform: "none!important",
    }),
    [],
  );

  const gameWon = useMemo(() => status === GameStatus.SUCCESS, [status]);

  return { sxTitleProps, gameWon, chosenLevel };
};
